import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box, Button, TextField, Typography,
  DialogContent, DialogActions, Alert,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Header from "../components/Header";

export default function ResetPassword() {
  const { token } = useParams();
  const theme = useTheme();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleReset = async () => {
    setError("");
    if (!password || !confirm) { setError("Merci de remplir les deux champs."); return; }
    if (password !== confirm) { setError("Les mots de passe ne correspondent pas."); return; }

    try {
      const res = await fetch(`/api/reset-password/${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ users_password: password }),
      });
      const data = await res.json();
      if (res.ok) {
        setSuccess(true);
        setTimeout(() => navigate("/connexion"), 2000);
      } else {
        setError(data.message || "Erreur lors de la modification.");
      }
    } catch {
      setError("Erreur serveur, réessaie plus tard.");
    }
  };

  return (
    <>
      <Header />
      <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
        <Box sx={{
          backgroundColor: theme.custom.mymodal.main,
          color: theme.custom.mymodal.text,
          border: theme.custom.mymodal.border,
          borderRadius: "5px",
          width: "100%",
          maxWidth: 400,
        }}>
          <Typography sx={{ textAlign: "center", p: "8px", fontWeight: "bold",
            color: theme.custom.mymodal.text, backgroundColor: theme.custom.mymodal.button,
            borderRadius: "5px 5px 0 0", textTransform: "uppercase" }}>
            Réinitialiser le mot de passe
          </Typography>

          <DialogContent>
            {success ? (
              <Alert severity="success" sx={{ mt: 1 }}>Mot de passe modifié ! Redirection…</Alert>
            ) : (
              <>
                <TextField label="Nouveau mot de passe" type="password" fullWidth
                  value={password} onChange={(e) => setPassword(e.target.value)} sx={{ mt: 1, mb: 2 }} />
                <TextField label="Confirme le mot de passe" type="password" fullWidth
                  value={confirm} onChange={(e) => setConfirm(e.target.value)}
                  onKeyDown={(e) => { if (e.key === "Enter") handleReset(); }} />
                {error && <Alert severity="error" sx={{ mt: 1 }}>{error}</Alert>}
              </>
            )}
          </DialogContent>

          {!success && (
            <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
              <Button onClick={handleReset} disabled={!password || !confirm}
                sx={{ color: theme.custom.mymodal.text, backgroundColor: theme.custom.mymodal.button }}>
                Mettre à jour
              </Button>
            </DialogActions>
          )}
        </Box>
      </Box>
    </>
  );
}
